export const name = "Main Card Game"
export const menu = "Main"
export const suggestedPlayer = "2-6 players"
export const color = {
  primary: {
    main:  '#c10016',
    contrastText: '#ffffff',
  },
  secondary: {
      main:  '#c10016',
  }
}
export const levels = ['Level 1 Perception', 'Level 2 Connection', 'Level 3 Reflection', 'Final Card']
export const isExpansion = true

export const backDesc = [
  "What's more romantic\n than being understood?"
]

export const instruction = [
  "Do you really know your best friend? How well do you know your mother, or sister, or anyone else close to you?",
  "WNRS is a purpose driven card game. 3 carefully crafted levels that allow you to deepen your existing relationships and create new ones.",
  "Ready?"
]

export const level1 = [ // 49 cards
  "What was your\n first impression\n of me?", //
  "What do you think is the hardest part of what I do for a living?",
  "What reality show do you\n think I'm most likely to binge\n watch? Explain.",
  "What does my style tell you about me?",
  "Do I seem like a cat or dog person?",
  "Do I seem like more of a\n creative type or analytical type?\n Explain.", //
  "How many speeding tickets do you think I've gotten in my life?",
  "Do I seem like someone who would get a name tattooed on myself? Why or why not?",
  "What do you think I'm most\n likely to splurge on?", //
  "Finish the sentence:\n Just by looking at\n you I'd think _________.", //
  "What character\n would I play in a\n movie?", //
  "Do I remind you of anyone?",
  "Who do you think my celebrity crush is?",
  "Do you think I've\n ever checked an\n ex's phone for\n evidence?", //
  "What's the first thing you noticed about me?",
  "What do you think my go to karaoke song is?",
  "If you were to buy me a present, knowing nothing about me other than what I look like, what would it be?",
  "What does my phone wallpaper tell you about me?",
  "Do I look kind?\n explain.", //
  "Do you think I fall in love easily? why or why not?",
  "As a child, what do\n you think I wanted\n to be?", //
  "Do you think I'm usually early, on time, or late to events? Explain.",
  "What subject do you think\n I thrived in at school? Did I\n fail any?", //
  "What compliment do you think I hear the most?",
  "Do I seem like a morning person or a night owl? why?",
  "What fast food restaurant do you think I'm most likely to drive through? What's my order?",
  "What is my body language\n telling you right now?", //
  "What does my Instagram\n tell you about me?", //
  "Do you think plants\n thrive or die in my\n care? Explain.", //
  "On a scale of 1-10, how messy\n do you think my car is? 1 being\n cleanest, 10 complete\n disaster. Explain.", //
  "Do you think I was\n popular in school?\n explain.", //
  "Do you think I've ever been\n fired from a job? If so, what\n for?", //
  "Do you think I intimidate\n others? Why or why\n not?", //
  "How likely am I to go camping? How high maintenance is my set up?",
  "What about me\n is most strange\n or unfamiliar to\n you?", //
  "What about me\n intrigues you?", //
  "If Myspace were still a thing\n what would my profile song be?", //

  "Wild Card Maintain eye contact\n for thirty seconds.\n What did you notice?", //
  "Wild Card Close your eyes. What\n color is my shirt?", //
  "Wild Card Ask and answer the\n next question in a\n different accent.\n (Both players)", //
  "Wild Card Draw a picture together.\n (30 seconds)", //
  "Wild Card Write down something others would never guess about you just by looking at you. (Both players) Compare.",
  "Wild Card Draw a portrait of each other to the best of your ability. (1 minute) Then exchange.",
  "Wild Card Think of your favorite brand\n of cereal. On the count of three\n say your answers out loud!\n (Both players)", //
  "Wild Card Think of your favorite childhood tv show of all time. On the count of three, say it out loud! (Both players)",
  "Wild Card Rate your dancing skills\n on a scale of 1-10. On the\n count of three, say your\n answers out loud! (Both players)",
  "Wild Card Close your eyes. What\n color are my eyes?", //
  "Wild Card Make an assumption about me.\n (Both players)", //
  "Reminder Let go of your\n attachment to\n the outcome.", //
];

export const level2 = [ // 52 cards
  "How can you become\n a better person?", //
  "What's your mother's name? And the most beautiful thing about her?",
  "If you could get to know someone in your life on a deeper level, who would it be and why?",
  "What's the most pain\n you've ever been in that\n wasn't physical?", //
  "Are you missing anyone\n right now? Do you think\n they are missing you\n too?", //
  "What is a dream you've let go of?",
  "What is the last thing you lied to your mother about?",
  "Have you ever told someone I love you but didn't mean it? If so, why?",
  "What are you still\n trying to prove to\n yourself?", //
  "Are you lying to\n yourself about\n anything?", //
  "What is your 1st love's name and the reason you fell in love with them?", // Changed him/her to them
  "What part of your life\n works? What part of\n your life hurts?", //
  "What lesson took you the longest to unlearn?",
  "If you have, when\n was the moment\n you realized you\n weren't invincible?", //
  "Do you think the image you have of yourself matches the image people see you as?",
  "If you could have it your\n way: Who would you be\n with? Where would you\n be? And what would you be\n doing?", //
  "Is there a feeling you miss?", // 
  "What's been your happiest memory this past year?",
  "When was the last\n time you surprised\n yourself?", //
  "How would you\n describe the feeling\n of being in love\n in one word?", //
  "What's your father's name? And tell me one thing about him.",
  "What are you more afraid of, failure or success? And why?",
  "What has been your earliest recollection of happiness?",
  "What do you crave\n more of?", //
  "What is a compliment\n you wish you received\n more frequently?", //
  "Have you changed your mind about anything recently?",
  "Describe your perfect day!",
  "What is the most\nunexplainable thing\n that's ever happened\n to you?", //
  "What would your younger\n self not believe about\n your life today?", //
  "What is something you wouldn't want to change about yourself?",
  "What title would you give this\n chapter in your life?", //
  "Has a stranger\n ever changed\n your life?", //
  "How are you,\n really?", //
  "When you're asked how\n are you, how often do you\n answer truthfully?", //
  "Finish the sentences:\n strangers would describe\n me as _________. Only I know\n that I am _________.", //
  "What question are you trying to\n answer most in your life right\n now?",
  "What's been the best\n compliment a stranger\n has ever given you?", //

  "Wild Card Staring contest. First\n to blink must reveal\n a personal problem\n and ask your partner\n for advice on how they\n might handle it.", //
  "Wild Card Ask a question you'd\n be too afraid to ask.\n Something you wouldn't\n dare to ask.", //
  "Wild Card Call someone you admire and tell them why you appreciate them! (Put on speaker phone)",
  "Wild Card Admit something.",
  "Wild Card Questions are an art form. Create your own question.",
  "Wild Card Think of something you strongly dislike that most people love. On the count of three, say it out loud! (Both players)",
  "Wild Card Swap seats with your partner.",
  "Wild Card Show the first photo in your camera roll. Explain.",
  "Wild Card Create a secret handshake.",
  "Wild Card Sing the chorus of your favorite song of all time. Get into it!",
  "Wild Card Draw your current mood. Then Compare. (Both players)",
  "Wild Card Both players write an\n embarrassing fun fact about\n yourselves. Play a game of\n rock, paper, scissors. Loser\n must reveal!", //
  "Wild Card Both players write the most important things in life to you. (30 seconds) Compare.",
  "Wild Card Press shuffle on your music library. Explain the first song that comes up!",
  "Reminder Be more interested\n in understanding\n others than being\n understood.", //
];

export const level3 = [ // 49 cards
  "How would you describe me to a stranger?",
  "What about me\n most surprised you?", //
  "What would be\n the perfect gift\n for me?",
  "What do you admire\n most about me?", //
  "Based on what you\n learned about me,\n what book would\n you recommend I\n read?",
  "What about me is hardest for you to understand?",
  "What am I most qualified to give advice about?",
  "What is one thing you think I can do that would dramatically improve my life?",
  "If we were in a band, what\n would our name be?", //
  "What can I help you with?", //
  "Based on what you\n learned about me,\n does my social media\n accurately reflect who I am?\n Why or why not?", //
  "What do I need to hear\n right now?", //
  "Based on what you know about me, do you have any Netflix recommendations?",
  "What do you think my\n superpower is?", //
  "What is a lesson you\n will take away from\n our conversation?", // 
  "When in this game did you feel most connected to me?",
  "How does one earn your\n vulnerability? Have I earned\n it? How can I earn more?", //
  "What do you think\n our most important\n similarity is?", //
  "What can we create\n together?", //
  "In one word, how\n would you describe\n our conversation?", //
  "What answer of mine made you light\n up?", //
  "When this game is over,\n what will you remember\n about me?", //
  "What parts of\n yourself do you see in me?", //
  "How do our personalities\n complement each other?", //
  "Why do you think we met?", // 
  "What do you think\n my weakness is?", //
  "What would make\n you feel closer\n to me?", //
  "What do you think I\n fear the most?", //
  "What has this\n conversation taught you\n about yourself?", //
  "What do you think I\n should know about\n myself that perhaps\n I'm unaware of?", //
  "What do you\n think my defining\n characteristic\n is?", //
  "Do you believe everyone has a\n calling? If so, do you think\n I've found mine?", //
  "What do you recommend\n I let go of, if anything?", //
  "In one word, describe\n how you feel right\n now.", //

  "Wild Card Give your partner a hug. Not the crappy kind. A ward fluffy one.",
  "Wild Card Write down one thing you want to let go of this year. Read out loud, then rip up together. (Both players)",
  "Wild Card Swap a song suggestion your\n partner may enjoy. (Both\n players)", //
  "Wild Card Dare your partner to do something outside of their comfort zone in the next week. (Both players)",
  "Wild Card Admit something.", //
  "Wild Card Give your partner a compliment you don't think they hear enough.",
  "Wild Card Write a song about your partner. (30 seconds) Then sing it aloud, get into it! (Both players)",
  "Wild Card Scroll through each other's Instagrams. Find the picture you feel best represents your partner's essence and comment on why.",
  "Wild Card Both players share\n something you're most\n grateful for in this\n current moment.",
  "Wild Card Play a round of rock, paper,\n scissors. Winner can ask their partner anything. Loser must answer.",
  "Wild Card Give each other nicknames!",
  "Wild Card Create your own question.\n Make it count.",
  "Wild Card Take a selfie together.",
  "Wild Card Write down a goal for this year. Fold & exchange. Hold each other accountable. (Both players)",
  "Wild Card Both players write a note\n to your younger selves.\n (1 minute) Option to compare.",
];

export const finalCard = [
  'Each player write a\n message to the other.\n Fold and exchange.\n Open only once you two\n have parted.' //
]